export default "__VITE_ASSET__CeOcgbXn__"